/**
 * API 클라이언트 설정
 */
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { authInterceptor } from './interceptors';
import { parseError } from './errorParser';

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

// Axios 인스턴스 생성 (Retrofit과 유사)
export const apiClient: AxiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 요청 인터셉터 (AuthInterceptor와 유사)
apiClient.interceptors.request.use(
    authInterceptor.onRequest,
    authInterceptor.onRequestError
);

// 응답 인터셉터
apiClient.interceptors.response.use(
    authInterceptor.onResponse,
    async (error) => {
        try {
            return await authInterceptor.onResponseError(error);
        } catch (err) {
            const parsed = parseError(err);
            return Promise.reject(parsed);
        }
    }
);
